import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import styled from 'styled-components';
import { hot } from 'react-hot-loader';
import debounce from 'lodash.debounce';
import { ParallaxProvider } from 'react-scroll-parallax';
import { windowResize } from 'src/redux/browser';
import 'src/styles/global';



import { prerenderStyles } from 'src/plugins/prerender';
import UpdateLanguage from 'src/plugins/language';

import Header from 'components/Header/Header';

class App extends Component {
  constructor(props) {
    super(props);
    window.addEventListener(
      'resize',
      debounce(() => props.windowResize(window.innerWidth, window.innerHeight), 200)
    );
  }

  componentDidMount() {
    new window.GambitSmoothScroll({
      amount: 150,
      speed: 1800,
    });
    prerenderStyles();
  }

  generateRoutes() {
    return process.env.__ROUTES__.map((route, index) => {
      const { path, component } = route;
      const Component = require(`src/${component}`).default;
      return <Route exact path={path} component={Component} key={index} />;
    });
  }

  render() {
    return (
      <Router>
        <Route
          render={({ location }) => (
            <ParallaxProvider>
              <AppWrapper>
                <Header />
                <TransitionGroup>
                  <CSSTransition
                    key={location.key}
                    timeout={500}
                    classNames="fade"
                  >
                    <Switch location={location}>{this.generateRoutes()}</Switch>
                  </CSSTransition>
                </TransitionGroup>
                <UpdateLanguage location={location} />
              </AppWrapper>
            </ParallaxProvider>
          )}
        />
      </Router>
    );
  }
}

const AppWrapper = styled.div`
  .fade-enter {
    opacity: 0;
  }
  .fade-enter.fade-enter-active {
    opacity: 1;
    transition: all 0.5s;
  }
  .fade-exit {
    opacity: 1;
  }
  .fade-exit.fade-exit-active {
    opacity: 0;
    transition: all 0.5s;
  }
`;



const mapStateToProps = state => ({
  browser: state.browser,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      windowResize
    },
    dispatch
  );

  export default hot(module)(connect(
    mapStateToProps,
    mapDispatchToProps
  )(App));



// WEBPACK FOOTER //
// ./src/App.js